import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { Button } from 'react-bootstrap';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import useLatLng from 'hooks/uselatlng/uselatlng';

const SiteListing = ({ match, siteLocationApproval }) => {
  const [formData, setFormatData] = useState({
    site_id: '',
    lattitude: '',
    longitude: '',
  });
  const { baseUrl } = useContext(BaseUrl);
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const islatlng = useLatLng();

  const headerBtns = () => {
    return (
      <Fragment>
        <Button onClick={handleSubmit} className="btn btn-primary">
          {localization.approve}
          <img src={Images?.ArrowRight} alt="" />
        </Button>
      </Fragment>
    );
  };
  useEffect(() => {
    setFormatData({
      ...formData,
      site_id: match.params.id,
      lattitude: islatlng?.lat,
      longitude: islatlng?.lng,
    });
  }, [match.params, islatlng]);

  const handleSubmit = () => {
    if (formData.lattitude === '' && formData.longitude === '') {
      setIsFiled(true);
      setIsModal(false);
    } else {
      setIsFiled(false);
      (async () => {
        setIsLoading(true);
        const res = await siteLocationApproval(formData);
        setIsLoading(false);
        if (res === true) {
          setIsModal(true);
        }
      })();
    }
  };
  const handleModalHide = () => setIsModal(false);

  return (
    <Layout
      title={localization.validateLocation}
      className={isFiled ? 'requiredFileds' : ''}
      Buttons={headerBtns}
      isGoback
      isLoading={isLoading}
    >
      <div className="panel-card">
        <div className="panel-heading">{localization.locationDetail}</div>
        <div className="panel-body">
          <div className="details-listing">
            <div className="details-list">
              <ConstantInput
                label={localization.lat}
                value={formData.lattitude && islatlng?.lat}
                disabled
                errorMsg={
                  formData.lattitude === ''
                    ? localization.isRequired
                    : localization.numberError
                }
                required
                type="number"
                handleChange={(val) =>
                  setFormatData({
                    ...formData,
                    lattitude: Number(islatlng?.lat).toFixed(3),
                  })
                }
              />
            </div>
            <div className="details-list">
              <ConstantInput
                label={localization.lng}
                value={formData.longitude}
                disabled
                errorMsg={
                  formData.longitude === ''
                    ? localization.isRequired
                    : localization.numberError
                }
                required
                isStarRequired={true}
                type="number"
                handleChange={(val) =>
                  setFormatData({
                    ...formData,
                    longitude: Number(islatlng?.lng).toFixed(3),
                  })
                }
              />
            </div>
          </div>
        </div>
      </div>
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.preB2bSuccess}</h5>
          <Link
            to={
              match.path.includes('pm-sites/')
                ? `${baseUrl}/pm-sities`
                : `${baseUrl}/site-listing`
            }
            className="btn btn-primary mb-4"
          >
            {match.path.includes('pm-sites/')
              ? localization.viewPmList
              : localization.viewSiteListing}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default SiteListing;
